var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"align-center layout px-4 pt-4 app--page-header",attrs:{"row":""}},[_c('div',{staticClass:"page-header-left"},[_c('h3',{staticClass:"pr-3"},[_vm._v(_vm._s(_vm.$route.meta.title || ''))])]),_c('v-spacer'),_c('div',{staticClass:"page-header-right"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }